import React from 'react';
import {deleteSense, deleteEncyclopedicInfos} from './SenseAction';
import Dict from 'dict-lib';
import {Button, Row, Col} from 'react-bootstrap';
import './../../../../_css/lexeme.css';
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";


export class SenseDelete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};

        this._handleRemove = this._handleRemove.bind(this);
    }

    _handleRemove() {
        if (this.props.isEncyclopedic) {
            deleteEncyclopedicInfos(this.props.item);
        } else
            deleteSense(this.props.item);
    }

    render() {

        return <div className="locVar-delete">
            <Row>
                <Col lg={8} md={8}
                     className="popup-label">{Dict.t(this.props.isEncyclopedic ? 'ASK_DELETE_ENCYCLOPEDIC' : 'ASK_DELETE_SENSE')}</Col>
                <Col lg={4} md={4}>
                    <SCSubmitButton onClick={this._handleRemove} text={Dict.t('YES')}/>
                </Col>
            </Row>
        </div>;
    }


}
